var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacionesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / notificaciones-outlined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-notificaciones-outlined",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48794284,19.015 L6.24194284,16.305 L6.24194284,16.007 L18.2419428,16.007 L18.2419428,16.296 L19.9969428,19.009 L4.48794284,19.015 Z M12.2419428,21.009 C11.5709428,21.009 10.9959428,20.597 10.7539428,20.013 L13.7299428,20.012 C13.4879428,20.596 12.9129428,21.009 12.2419428,21.009 L12.2419428,21.009 Z M12.2609428,5.005 C13.8769428,5.005 15.3859428,5.725 16.5109428,7.032 C17.6119428,8.31 18.2419428,10.045 18.2419428,11.79 L18.2419428,12.008 L6.24194284,12.008 L6.24194284,11.48 C6.24194284,7.728 8.77294284,5.005 12.2609428,5.005 L12.2609428,5.005 Z M12.2419428,3 C12.9859428,3 13.6059428,3.509 13.7919428,4.194 C13.3029428,4.073 12.7919428,4.005 12.2609428,4.005 C11.7159428,4.005 11.1949428,4.062 10.6999428,4.167 C10.8949428,3.496 11.5089428,3 12.2419428,3 L12.2419428,3 Z M6.24194284,15.007 L18.2419428,15.007 L18.2419428,13.007 L6.24194284,13.007 L6.24194284,15.007 Z M21.4399428,19.397 L19.2419428,16.001 L19.2419428,11.79 C19.2419428,8.673 17.4979428,5.747 14.8479428,4.563 C14.8219428,3.146 13.6649428,2 12.2419428,2 C10.8439428,2 9.70794284,3.108 9.64294284,4.49 C6.92294284,5.551 5.24194284,8.26 5.24194284,11.48 L5.24194284,16.009 L3.04494284,19.405 C2.90494284,19.685 3.10894284,20.015 3.42294284,20.015 L9.71094284,20.013 C9.98994284,21.156 11.0149428,22.009 12.2419428,22.009 C13.4689428,22.009 14.4949428,21.155 14.7729428,20.011 L21.0619428,20.008 C21.3759428,20.008 21.5799428,19.678 21.4399428,19.397 L21.4399428,19.397 Z",
    id: "Fill-1",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionesOutlined);
export default __webpack_public_path__ + "static/media/notificaciones-outlined.5366e1ecb3558fea566ab236cc83bd1b.svg";
export { ForwardRef as ReactComponent };